<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">
        <div class="mt-3">
          <label class="txt-right required">Tên công ty</label>
          <!-- <div class="p-col"> -->
          <InputText
            v-model="name"
            id="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="mode=='edit'"
          />
        </div>
        <div class="mt-2">
          <label class="txt-right required">Loại công ty</label>
          <Dropdown v-model="type" id="type" :options="company_types" optionLabel="label" placeholder="Chọn loại công ty (type)" :disabled="mode=='edit'"/>
          <input class="input_tmp_validator" id="type_add" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Giám đốc</label>
          <InputText
            v-model="manager"
            id = "manager"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập (tối đa 255 ký tự)"
            maxLength="255"
          />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Địa chỉ</label>
          <!-- <div class="p-col"> -->
          <div class="row">
            <div class="col-lg-4">
              <Dropdown v-model="state" :options="listState" optionLabel="name" placeholder="Tỉnh/TP" />
              <input class="input_tmp_validator" id="state_id" />
            </div>
            <div class="col-lg-4">
              <Dropdown v-model="district" :options="listDistrict" optionLabel="name" placeholder="Quận/huyện" />
              <input class="input_tmp_validator" id="district_id" />
            </div>
            <div class="col-lg-4">
              <Dropdown v-model="ward" :options="listWard" optionLabel="name" placeholder="Phường/xã" />
              <input class="input_tmp_validator" id="ward_id" />
            </div>
          </div>
        </div>
        <div class="mt-3">
          <label class="txt-right required">Số nhà, tên đường</label>
          <InputText
            v-model="street"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="street" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Số điện thoại</label>
          <InputText v-model="phone" type="text" class="cs-input input-text-box" placeholder="Nhập" id="phone" @input="phone = phone.replace(/[^0-9]/g, '')"/>
        </div>
        <div class="mt-3">
          <label class="txt-right">Email</label>
          <InputText v-model="email" type="text" class="cs-input input-text-box" placeholder="mail@example.com" id="email"/>
        </div>
        <div class="mt-3">
          <label class="txt-right">Website</label>
          <InputText v-model="website" type="text" class="cs-input input-text-box" placeholder="Nhập" id="website"/>
        </div>
        <div class="mt-3">
          <label class="txt-right">Mã số thuế</label>
          <InputText v-model="tax_code" type="text" class="cs-input input-text-box" placeholder="Nhập" id="tax_code"/>
        </div>
        <div class="mt-3 d-flex align-items-center p-0">
          <Checkbox id="active" v-model="active" :binary="true" />
          <label for="active" class="m-0 ml-2">Hiển thị</label>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
import ApiRepository from "@/core/ApiRepository";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      name: "",
      manager: "",
      address: "",
      phone: "",
      email: "",
      website: "",
      tax_code: "",
      active: true,
      type : null,
      company_types : [
        {value : "LLC" , label: "TNHH"},
        {value : "JSC" , label : "Cổ phần"},
        {value : "PE" , label : "Tư nhân"},
      ],
      street: "",
      ward_id: "",
      district_id: "",
      state_id: "",
      state: {},
      district: {},
      ward: {},
      listState: [],
      listDistrict: [],
      listWard: [],
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    await this.getListState();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
        this.name = this.model.name;
        this.manager = this.model.manager;
        this.phone = this.model.phone;
        this.email = this.model.email;
        this.website = this.model.website;
        this.tax_code = this.model.tax_code;
        this.active = this.model.active;
        this.state = this.model.state;
        setTimeout(() => {
          this.district = this.model.district;
          setTimeout(() => {
            this.ward = this.model.ward;
            this.$commonFuction.is_loading(false);
          }, 1000);
        }, 1000);
        this.street = this.model.street;
        if (this.model.type) {
          this.type = this.company_types.find((item) => item.value === this.model.type);
        }
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
    }
  },
  watch: {
    async "state"() {
      if (!this?.district?.state_id || this?.district?.state_id != this?.state?.id) {
        this.district = {};
      }
      await this.getListDistrict();
    },
    async "district"() {
      if (!this?.ward?.state_id || this?.ward?.state_id != this?.state?.id || !this?.ward?.district_id || this?.ward?.district_id != this?.district?.id) {
        this.ward = {};
      }
      await this.getListWard();
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async getListState() {
      var gqLQueryList = DataServices.getList("state", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" },
        },
      });
      var listData = resData.data["state"];
      this.listState = listData;
    },
    async getListDistrict() {
      var gqLQueryList = DataServices.getList("district", {"fields": "id, name"});
      var where = {
          state_id: {_eq: this.state?.id},
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" },
        },
      });
      var listData = resData.data["district"];
      this.listDistrict = this.state ? listData : [];
    },
    async getListWard() {
      var gqLQueryList = DataServices.getList("ward", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
          state_id: {_eq: this.state?.id},
          district_id: {_eq: this.district?.id},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" },
        },
      });
      var listData = resData.data["ward"];
      this.listWard = this.district?.id ? listData : [];
    },
    async validateData() {
      this.validationErrors = {};

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Tên công ty không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên công ty không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }

      let type_add = document.getElementById("type_add");
      if (
        this.type == undefined ||
        this.type == null ||
        this.type == ""
      ) {
        type_add.setCustomValidity("Loại công ty không được để trống!");
      } else {
        type_add.setCustomValidity("");
      }

      let manager_add = document.getElementById("manager");
      if (
        this.manager == undefined ||
        this.manager == null ||
        this.manager == ""
      ) {
        manager_add.setCustomValidity("Tên giám đốc không được để trống!");
      } else if (this.manager.length > 255) {
        manager_add.setCustomValidity("Tên giám đốc không được quá 255 ký tự!");
      } else {
        manager_add.setCustomValidity("");
      }

      let phone_add = document.getElementById("phone");
      if (
        this.phone == undefined ||
        this.phone == null ||
        this.phone == ""
      ) {
        phone_add.setCustomValidity("Số điện thoại không được để trống!");
      } else if (this.phone.length > 20) {
        phone_add.setCustomValidity("Số điện thoại không được quá 20 ký tự!");
      } else {
        phone_add.setCustomValidity("");
      }

      let website_add = document.getElementById("website");
      if ( this.website != "" && !this.validateUrl(this.website)
      ) {
        website_add.setCustomValidity("Website không hợp lệ!");
      } else {
        website_add.setCustomValidity("");
      }

      let email_add = document.getElementById("email");
      if (
        this.email != "" &&
        !this.validateEmail()
      ) {
        email_add.setCustomValidity("Email không hợp lệ!");
      } else {
        email_add.setCustomValidity("");
      }

      let state_id_add = document.getElementById("state_id");
      if (
        this.$commonFuction.isEmptyObject(this.state)
      ) {
        state_id_add.setCustomValidity("Tỉnh/TP không được để trống!");
      } else {
        state_id_add.setCustomValidity("");
      }

      let district_id_add = document.getElementById("district_id");
      if (
        this.$commonFuction.isEmptyObject(this.district)
      ) {
        district_id_add.setCustomValidity("Quận/huyện không được để trống!");
      } else {
        district_id_add.setCustomValidity("");
      }

      let ward_id_add = document.getElementById("ward_id");
      if (
        this.$commonFuction.isEmptyObject(this.ward)
      ) {
        ward_id_add.setCustomValidity("Phường/xã không được để trống!");
      } else {
        ward_id_add.setCustomValidity("");
      }

      let street_add = document.getElementById("street");
      if (this.$commonFuction.isEmpty(this.street)) {
        street_add.setCustomValidity("Số nhà, tên đường không được để trống!");
      } else {
        street_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateUrl(urlStr) {
      try {
        if (!urlStr) {
          return true;
        }
        const url = new URL(urlStr);
        if ((url.protocol === "https:" || url.protocol === "http:") && url.host !== "" && url.pathname !== "") {
          const pattern = new RegExp(
            "^([a-zA-Z]+:\\/\\/)?" + // protocol
              "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
              "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
              "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
              "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
              "(\\#[-a-z\\d_]*)?$", // fragment locator
            "i"
          );
          return pattern.test(urlStr);
        }
        return false;
      }catch(err) {
        console.log(err);
        return false;
      }
    },
    async existEmail() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/users/check_email_exist", {email: this.email, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var address = [];
      address.push(this.street);
      address.push(this.ward.name);
      address.push(this.district.name);
      address.push(this.state.name);
      var params = {
        name: this.name,
        type: this.type.value,
        manager: this.manager,
        phone: this.phone,
        email: this.email,
        website: this.website,
        tax_code: this.tax_code,
        address: address.join(", "),
        street: this.street,
        ward_id: this.ward.id,
        district_id: this.district.id,
        state_id: this.state.id,
        active: this.active,
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
</style>
